function FieldErrors ({ error, otherClassName = '' }) {
  if (error) {
    let message = error.message
    if (!message && error.type === 'required') {
      message = 'Required'
    }
    if (!message) {
      message = 'Error'
    }
    return (
      <span className={`inline-block text-xs text-red-40 ${otherClassName}`}>
        {message}
      </span>
    )
  }
  return null
}

export default FieldErrors
